import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { JornadaPonto } from '../../api.service';

@Component({
  selector: 'app-grade-horarios-jornada',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './grade-horarios-jornada.component.html'
})
export class GradeHorariosJornadaComponent {
  @Input({ required: true }) jornada!: JornadaPonto;

  @Output() jornadaChange = new EventEmitter<JornadaPonto>();
  @Output() adicionarHorario = new EventEmitter<void>();
  @Output() removerHorario = new EventEmitter<number>();

  emitirJornada() {
    this.jornadaChange.emit(this.jornada);
  }
}
